import React from "react";
import { useField } from "react-final-form";

import { NumberInputEx } from "./NumberInputEx";

const isNonEmptyString = (value) => typeof value === 'string' && value !== '';

// "5." or "5.0" or "5.00" or "5.10" - ends with dot or digit(s) followed by zero
const isIncompleteDecimal = (value) => /[.,]$|[.,]\d*0$/.test(value);

const toRate = (value, precision) => Number((parseFloat(value) / 100).toFixed(precision));

const format = (value) => {
	if (typeof value !== 'number') return value;
	return parseFloat((value * 100).toPrecision(15));
};

export const RateAsPercentageInput = ({ source, digitsCount = 5, ...rest }) => {
	const { input } = useField(source);
	const precision = digitsCount + 2;

	const parse = React.useCallback((value) => {
		if (!isNonEmptyString(value)) return value;
		if (isIncompleteDecimal(value)) return value;
		return toRate(value, precision);
	}, [precision]);

	const handleBlur = React.useCallback(() => {
		if (isNonEmptyString(input.value)) {
			input.onChange(toRate(input.value, precision));
		}
	}, [input, precision]);

	return (
		<NumberInputEx
			{...rest}
			source={source}
			type="float"
			digitsCount={digitsCount}
			format={format}
			parse={parse}
			onBlur={handleBlur}
		/>
	);
};
